module.exports = __webpack_public_path__ + "img/1F3F3-FE0F-200D-26A7-FE0F.4fa7d549.svg";